import React from 'react';
import { useField } from '~/hooks';
import FieldControl from './FieldControl';
import SingleSelect from './SingleSelect';

const options = [
  { id: 'high', name: 'High' },
  { id: 'medium', name: 'Medium' },
  { id: 'low', name: 'Low' },
];

function OpportunityPrioritySelect({ component: SelectComponent = SingleSelect, ...props }) {
  return (
    <SelectComponent {...props}>
      {options.map(({ id, name }) => (
        <option key={id} value={id}>
          {name}
        </option>
      ))}
    </SelectComponent>
  );
}

function FieldOpportunityPrioritySelect(props) {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;

  return (
    <FieldControl error={error}>
      <OpportunityPrioritySelect {...field} {...props} />
    </FieldControl>
  );
}

export default OpportunityPrioritySelect;
export { FieldOpportunityPrioritySelect };
